import { CheckIcon, RocketLaunchIcon } from "@heroicons/react/24/outline";
import { useAmplitude } from "lib/amplitude/Amplitude";
import Link from "next/link";
import type { ReactNode } from "react";

interface IFeatureBoxProps {
  displayOrigin: string;
  featureHighlights: string[];
  buttonText?: string;
  callToActionText?: ReactNode;
}

export default function FeatureBox({
  displayOrigin,
  callToActionText,
  featureHighlights,
  buttonText = "Ver mais detalhes",
}: IFeatureBoxProps) {
  const amplitude = useAmplitude();

  return (
    <div className="bg-brand-50 flex w-full flex-col space-y-4 border-t border-t-slate-200 pt-4 font-aeonik font-normal">
      <div className="flex flex-col items-center space-y-1">
        <div className="border-2 border-brand bg-brand/10 p-2 squircle">
          <RocketLaunchIcon strokeWidth={1.5} className="h-6 w-6 text-brand" />
        </div>

        <div>
          <h2 className="inline-flex px-4 py-1 text-xl font-bold italic tracking-wide text-brand">Premium</h2>
        </div>

        <em className="text-center text-sm tracking-wide text-gray-500">{callToActionText}</em>
      </div>

      {featureHighlights.length > 0 && (
        <div className="space-y-2">
          {featureHighlights.map((line) => {
            return (
              <li key={line} className="flex items-center space-x-2">
                <div className="rounded-full bg-violet-100 p-1 text-violet-600">
                  <CheckIcon className="h-3 w-3" strokeWidth={3} />
                </div>
                <span className="text-sm font-medium tracking-wide text-slate-700">{line}</span>
              </li>
            );
          })}

          <p className="text-sm italic tracking-wide text-gray-500">...e muito mais!</p>
        </div>
      )}

      <Link href="/premium" as="/premium" passHref={true}>
        <a
          href="/premium"
          className="rounded-full bg-brand p-2 text-center text-base font-medium text-white hover:bg-brand/80"
          onClick={() => {
            amplitude.logEvent("Click on link to become Premium", {
              origin: displayOrigin,
            });
          }}
        >
          {buttonText}
        </a>
      </Link>
    </div>
  );
}
